import { useContext } from 'react';
import { useQuery } from '@tanstack/react-query';

import { UserContext } from '~/components/providers/UserProvider';

import { getMissionDetail } from '../services/missions.api';
import { MissionsQueryKeys } from '../constants/query';

/**
 * Fetches a single mission's detail (incl. `rewards`) by assignment id.
 * Shared by both Connected mission modals — the detail endpoint is the only
 * source of `mission.rewards`, which the list response omits.
 */
export const useGetMissionDetail = (assignmentId?: string) => {
  const { user } = useContext(UserContext);

  // eslint-disable-next-line local-rules/require-query-stale-time
  const { data: missionAssignment, isLoading, isError } = useQuery({
    queryKey: MissionsQueryKeys.MISSION_DETAIL(assignmentId),
    queryFn: () => getMissionDetail(assignmentId as string),
    enabled: !!assignmentId && !!user,
  });

  return {
    missionAssignment,
    isLoading,
    isError,
  };
};
